import sidebar from '@/data/sidebar';

export function getGlobalFiltersFromStorage() {
	try {
		return JSON.parse(localStorage.getItem('globalFilters')) || {};
	} catch {
		return {};
	}
}

export function getSelectedAccountId() {
	const filters = getGlobalFiltersFromStorage();
	const account = filters?.account;
	if (!account || account === 0) {
		return undefined;
	}
	const accountId = account.id;
	if (accountId === undefined || accountId === null || Number(accountId) === 0) {
		return undefined;
	}
	return accountId;
}

export function clearSelectedAccountFilter() {
	const filters = getGlobalFiltersFromStorage();
	localStorage.setItem('globalFilters', JSON.stringify({ ...filters, account: 0 }));
}

export function isAccountsScopedRoute(name) {
	return name === 'accounts' || (typeof name === 'string' && name.startsWith('accounts-info'));
}

export function isAccountsInfoRoute(name) {
	return typeof name === 'string' && name.startsWith('accounts-info');
}

const sidebarItems = () =>
	sidebar.links.flatMap((link) => (link.children?.length ? link.children : [link]));

export function isAccountFilterablePath(path) {
	if (typeof path !== 'string') {
		return false;
	}
	const match = sidebarItems()
		.filter((item) => item.path)
		.map((item) => ({ ...item, path: item.path.split('?')[0] }))
		.filter((item) => path === item.path || path.startsWith(`${item.path}/`))
		.sort((left, right) => right.path.length - left.path.length)[0];
	return Boolean(match?.filtered);
}
